import { inject, Injectable } from '@angular/core';
import { HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { DocumentDto, UploadDocumentRequest } from '../models/document.model';

@Injectable({ providedIn: 'root' })
export class DocumentService {
  private readonly api = inject(ApiService);

  getByFolder(folderId: number | null): Observable<DocumentDto[]> {
    const path = folderId === null
      ? '/folders/root/documents'
      : `/folders/${folderId}/documents`;

    return this.api.get<DocumentDto[]>(path);
  }

  search(query: string, folderId: number | null): Observable<DocumentDto[]> {
    return this.api.get<DocumentDto[]>('/documents/search', {
      query,
      folderId: folderId ?? ''
    });
  }

  upload(request: UploadDocumentRequest): Observable<HttpEvent<DocumentDto>> {
    const formData = new FormData();
    formData.append('folderId', String(request.folderId));
    formData.append('title', request.title);
    formData.append('description', request.description ?? '');
    formData.append('file', request.file);

    return this.api.postFormWithProgress<DocumentDto>('/documents/upload', formData);
  }

  download(documentId: number) {
    return this.api.download(`/documents/${documentId}/download`);
  }

  delete(documentId: number) {
    return this.api.delete<void>(`/documents/${documentId}`);
  }
}
